'use client';
import { HubspotIntegrationTypeEnum } from 'gql/graphql';
import { GithubIcon, GoogleIcon, HubDBIcon, HubSpotIcon } from 'lib/svgs/IntegrationsIcons';
import { useTranslations } from 'next-intl';
import { useFeatureFlags } from 'providers/ClientProviders/useFeatureFlags';
import { FC, PropsWithChildren } from 'react';
import CardIntegration from './CardIntegration';
import GoogleConnect from './GoogleConnect';
import HubSpotConnect from './HubSpotConnect';

const ListIntegrations: FC<PropsWithChildren<unknown>> = () => {
  const t = useTranslations();
  const { data: featureFlags } = useFeatureFlags();

  return (
    <div className="mt-4 flex gap-8">
      {featureFlags?.integrationHubSpotEnabled && (
        <CardIntegration
          title={t('integrations.list.hubspot')}
          href="/integrations/hubspot"
          label={t('integrations.connect')}
          icon={<HubSpotIcon />}
        >
          <HubSpotConnect
            appClientId={process.env.NEXT_PUBLIC_HUBSPOT_CLIENT_ID}
            viewLink="/integrations/hubspot"
            scope="content oauth forms"
            type={HubspotIntegrationTypeEnum.Content}
          />
        </CardIntegration>
      )}
      {featureFlags?.integrationHubSpotEnabled && (
        <CardIntegration
          title={t('integrations.list.hubdb')}
          href="/integrations/hubdb"
          label={t('integrations.connect')}
          icon={<HubDBIcon />}
        >
          <HubSpotConnect
            appClientId={process.env.NEXT_PUBLIC_HUBSPOT_HUB_DB_CLIENT_ID}
            viewLink="/integrations/hubdb"
            scope="hubdb"
            type={HubspotIntegrationTypeEnum.Hubdb}
          />
        </CardIntegration>
      )}
      {featureFlags?.integrationGoogleEnabled && (
        <CardIntegration
          title={t('integrations.list.google')}
          href="/integrations/google"
          label={t('integrations.connect')}
          icon={<GoogleIcon />}
        >
          <GoogleConnect />
        </CardIntegration>
      )}
      <CardIntegration
        title={t('integrations.list.github')}
        href="/integrations/github"
        label={t('integrations.connect')}
        icon={<GithubIcon />}
      />
    </div>
  );
};

export default ListIntegrations;
